import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Question, Test } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
type QuestionType = Question;

interface CurrentTestState {
  currTest: Test;
  index: number;
  questions: QuestionType[];
}

// Define the initial state using that type
const initialState: CurrentTestState = {
  currTest: {
    addedOn: null,
    description: "",
    formationId: 0,
    id: 0,
    lastModifiedOn: null,
    title: "",
  },
  index: 0,
  questions: [],
};

export const currentTestSlice = createSlice({
  name: "currentTest",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setCurrentTest: (state, action: PayloadAction<Test>) => {
      state.currTest = action.payload;
    },
    setIndex: (state, action: PayloadAction<number>) => {
      state.index = action.payload;
    },
    setQuestions: (state, action: PayloadAction<QuestionType[]>) => {
      state.questions = action.payload;
    },
  },
});

export const { setCurrentTest, setIndex, setQuestions } =
  currentTestSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const selectCurrentTest = (state: RootState) => state.currentTest;
export default currentTestSlice.reducer;
